import * as Joi from 'joi';
import { Currencies } from '../enums/currencies.enum';
import { GetEnumKeyByEnumValue } from '../helpers/payment-link.helper';

const stringWithNumbersOnlyRegEx = /^\d+$/; // @ref https://github.com/sideway/joi/issues/1157#issuecomment-293538673

//Based of ItemAmountSchema
// const ProductValueSchema = Joi.object()
//   .keys({
//     price: Joi.number().min(1).max(9999999).required().messages({
//       "any.required": "Price is required.",
//       "number.base": "Price is invalid.",
//       "number.min": "Price must range from 1 to 9999999.",
//       "number.max": "Price must range from 1 to 9999999.",
//     }),
//     currency: Joi.enum([GetEnumKeyByEnumValue(Currencies, Currencies.PHP)]),
//   })
//   .required()
//   .messages({
//     "any.required": "Value is required.",
//     "object.base": "Value must be an object.",
//   });

//Based of ItemsSchema
export const ProductSchema = Joi.object({
  name: Joi.string().trim().required().messages({
    'any.required': 'Product name is required.',
    'string.base': 'Product name is invalid.',
    'string.empty': 'Product name is invalid.',
  }),
  code: Joi.string().trim().required().messages({
    'any.required': 'Product code is required.',
    'string.base': 'Product code is invalid.',
    'string.empty': 'Product code is invalid.',
  }),
  description: Joi.string().trim().min(1).max(120).required().messages({
    'any.required': 'Product description is required.',
    'string.base': 'Product description is invalid.',
    'string.empty': 'Product description is invalid.',
    'string.min': 'Product description must have at most 120 characters only.',
    'string.max': 'Product description must have at most 120 characters only.',
  }),
  quantity: Joi.number().integer().min(1).required().messages({
    'any.required': 'Product quantity is required.',
    'number.base': 'Product quantity is invalid.',
    'number.integer': 'Product quantity is invalid.',
    'number.min': 'Product quantity must be at least 1.',
  }),
  price: Joi.number().min(1).max(9999999).required().messages({
    'any.required': 'Price is required.',
    'number.base': 'Price is invalid.',
    'number.min': 'Price must range from 1 to 9999999.',
    'number.max': 'Price must range from 1 to 9999999.',
  }),
  currency: Joi.string().valid(Currencies.PHP, Currencies.USD),
  cardFee: Joi.number().precision(2).required().messages({
    'any.required': 'Card fee is required.',
    'number.base': 'Card fee must be a decimal',
    'number.precision': 'Card fee must have only 2 decimal places',
  }),
  qrFee: Joi.number().precision(2).required().messages({
    'any.required': 'QR fee is required.',
    'number.base': 'QR fee must be a decimal',
    'number.precision': 'QR fee must have only 2 decimal places',
  }),
});
